import { createSlice } from '@reduxjs/toolkit';
import { LoadMarketPlacePricing } from './load-marketplace-pricing.thunk';
import { MarketplacePricingState } from './marketplace-pricing.state';
import { BrokerageFeeRefundStatus } from './models/brokerage-fee-refund-status.enum';

const initialState: MarketplacePricingState = {
    pricing: {
        requestPreorderAgreementButtonText: '',
        discountBrokeragePricing: {
            feeCalculatorSettings: {
                innerRevenueMultiplePercent: 0,
                innerValuePerDvmPercent: 0,
                outerRevenueMultiplePercent: 0,
                outerValuePerDvmPercent: 0,
                middleOfRangeRevenueMultiple: 0,
                middleOfRangeValuePerDvm: 0,
            },
            transactionFeeSchedule: [],
            transactionFees: {
                idNdaFeePerBuyer: 0,
                idNdaFirstXCount: 0,
                idNdaFeeRefundable: BrokerageFeeRefundStatus.NonRefundable,
                idNdaFeeCreditable: 0,
                dataNdaFeePerBuyer: 0,
                dataNdaFirstXCount: 0,
                dataNdaFeeRefundable: BrokerageFeeRefundStatus.NonRefundable,
                dataNdaFeeCreditable: 0,
                financialModelFeePerBuyer: 0,
                financialModelFirstXCount: 0,
                financialModelFeeRefundable:
                    BrokerageFeeRefundStatus.NonRefundable,
                financialModelFeeCreditable: 0,
                buyerMeetingVirtualCredit: 0,
                buyerMeetingInPersonCredit: 0,
                buyerMeetingRefundable: BrokerageFeeRefundStatus.NonRefundable,
                buyerMeetingCreditable: 0,
                applicationFee: 0,
                applicationFeeRefundable:
                    BrokerageFeeRefundStatus.NonRefundable,
                applicationFeeCreditable: 0,
                lateFeeFirstOccurrence: 0,
                lateFeeAdditionalOccurrence: 0,
                lateFeeRefundable: BrokerageFeeRefundStatus.NonRefundable,
                lateFeeCreditable: 0,
                suspensionFee: 0,
                suspensionFeePerDvm: 0,
                tailPeriodMonths: 0,
            },
        },
        fullServiceBrokeragePricing: {
            feeCalculatorSettings: {
                innerRevenueMultiplePercent: 0,
                innerValuePerDvmPercent: 0,
                outerRevenueMultiplePercent: 0,
                outerValuePerDvmPercent: 0,
                middleOfRangeRevenueMultiple: 0,
                middleOfRangeValuePerDvm: 0,
            },
            transactionFeeSchedule: [],
            transactionFees: {
                idNdaFeePerBuyer: 0,
                idNdaFirstXCount: 0,
                idNdaFeeRefundable: BrokerageFeeRefundStatus.NonRefundable,
                idNdaFeeCreditable: 0,
                dataNdaFeePerBuyer: 0,
                dataNdaFirstXCount: 0,
                dataNdaFeeRefundable: BrokerageFeeRefundStatus.NonRefundable,
                dataNdaFeeCreditable: 0,
                financialModelFeePerBuyer: 0,
                financialModelFirstXCount: 0,
                financialModelFeeRefundable:
                    BrokerageFeeRefundStatus.NonRefundable,
                financialModelFeeCreditable: 0,
                buyerMeetingVirtualCredit: 0,
                buyerMeetingInPersonCredit: 0,
                buyerMeetingRefundable: BrokerageFeeRefundStatus.NonRefundable,
                buyerMeetingCreditable: 0,
                applicationFee: 0,
                applicationFeeRefundable:
                    BrokerageFeeRefundStatus.NonRefundable,
                applicationFeeCreditable: 0,
                lateFeeFirstOccurrence: 0,
                lateFeeAdditionalOccurrence: 0,
                lateFeeRefundable: BrokerageFeeRefundStatus.NonRefundable,
                lateFeeCreditable: 0,
                suspensionFee: 0,
                suspensionFeePerDvm: 0,
                tailPeriodMonths: 0,
            },
        },
    },
    isLoading: false,
    status: 'loading',
    error: '',
};

const marketplacePricingSlice = createSlice({
    name: 'marketplacePricing',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(LoadMarketPlacePricing.pending, (state) =>
                setPendingState(state)
            )
            .addCase(LoadMarketPlacePricing.fulfilled, (state, action) => {
                const pricing = action.payload.data;
                state.pricing = pricing;
                setSucceededState(state);
            })
            .addCase(LoadMarketPlacePricing.rejected, (state) =>
                setRejectedState(state)
            );
    },
});

const setRejectedState = (state: any) => {
    state.isLoading = false;
    state.status = 'failed';
    state.error = state;
};

const setPendingState = (state: any) => {
    state.isLoading = true;
    state.status = 'loading';
    state.error = '';
};

const setSucceededState = (state: any) => {
    state.isLoading = false;
    state.status = 'succeeded';
    state.error = '';
};
export const {} = marketplacePricingSlice.actions;
export default marketplacePricingSlice.reducer;
